<template>
  <div class="">
    <div class="head-title">通讯录管理</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>1. 展示企业员工头像、名称、所在部门、客户数等相关信息。</p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <nav>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          style="margin-right: 2.4rem"          :loading="updateLoading"
          :disabled="updateLoading"
          @click="getRenew"
          >{{ btnText }}</el-button
        >
        <span class="shij">
          <el-input
            clearable
            style="width: 35rem; margin: 0 0 0 2rem"  placeholder="请输入成员名称搜索"
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          >
          <el-button slot="append" @click="rune()" type="primary"
            >查询</el-button
          >
          </el-input>

        </span>
      </nav>
      <el-table
        :data="tableData.data"
        border
        style="width: 100%; margin-top: 2.0rem"
        v-loading="tableLoading"
      >
        <el-table-column prop="avatar" label="成员头像" style="width:25%">
          <template slot-scope="scope">
            <el-image
              style="width: 3.2rem; height: 3.2rem"
              :src="scope.row.avatar"
              :preview-src-list="[scope.row.avatar]"
              fit="scale-down"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="成员名称"
          style="width:25%"
        ></el-table-column>

        <el-table-column
        style="width:25%"
          prop="department_name"
          label="部门"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              size="mini"
              style="margin: .2rem"
              v-for="t in scope.row.department_name_array"
              :key="t"
              >{{ t }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="customer_count" label="客户数" style="width:25%"></el-table-column>
      </el-table>
      <div class="paging">
        <pagination
          :total="tableData.total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="userTable"
        />
      </div>
      <!-- <openData type="userName" openid="wo-t_PCwAAnteW9qBIYOJ8X2UnBCDkCg"></openData> 通讯录组件-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
import openData from "@/components/openData";
export default {
  name: "monitoring",
  components: {
    Pagination,
    openData,
  },
  data() {
    return {
      title: {},
      tooken: "",
      tableData: {
        total: 0,
        data: [],
      },
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
        customer_deal_days: "",
        customer_follow_days: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      customer_deal_days: "",
      customer_follow_days: "",
      lock: true,
      code: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      updateLoading: false,
      btnText: "同步通讯录",
      tableLoading: true,
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    async getRenew() {
      this.updateLoading = true;
      // 拉取更新数据
      const ws = new WebSocket("wss://api.weijub.com:4431");
      ws.onopen = () => {
        console.log("连接成功");
        this.btnText = "数据拉取中";
        ws.send(JSON.stringify({ uid: this.tooken.account_id, type: "bind" }));
      };
      ws.onmessage = (e) => {
        // console.log("收到服务端的消息：" + JSON.stringify(e.data));
        this.updateLoading = false;
        this.btnText = "同步通讯录";
        this.$message.success("同步成功");
        this.tableData.data = [];
        this.userTable();
      };
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    //  页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/Assistant/getAddressBook",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.name,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          res.data.data.data.forEach((i) => {
            const regex = /，|,/gim;
            const tags = i.department_name.replace(regex, ",");
            i.tags = tags.split(",");
          });
          this.tableLoading = false;
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Assistant/getAddressBook",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o, l, p) {
      this.yeshu = 1;
      this.ele = e;
      this.bianjile = o;
      this.customer_follow_days = l;
      this.customer_deal_days = p;
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/editCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.bianjile,
            id: this.ele,
            customer_follow_days: this.customer_follow_days,
            customer_deal_days: this.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/addCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.name,
            customer_follow_days: this.form.customer_follow_days,
            customer_deal_days: this.form.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerLevel/delCustomerLevel",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.groupSend {
  height: 100%;
}
.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 2.4rem;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
</style>
